import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/internal/Observable';

import { Attraction } from '../models';

export interface AttractionApi {
    items: Attraction[];
    total_count: number;
}

@Injectable({
    providedIn: 'root'
})
export class AttractionService {
    private _attractionRoute = '/api/attractions/';
    private headerOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

    public pageLayoutBeingViewed: any = {};

    constructor(
        private httpClient: HttpClient
    ) { }


    setAttractionToBeViewed(_attraction: any) {
        this.pageLayoutBeingViewed = _attraction;
    }


    getAttractionToBeViewed() {
        return this.pageLayoutBeingViewed;
    }


    get(): Observable<any[]> {
        return this.httpClient.get<any[]>(this._attractionRoute);
    }


    getById(_attractionId: string): Observable<any> {
        return this.httpClient.get<any>(this._attractionRoute + _attractionId);
    }


    getByName(pageLayoutName: string): Observable<Attraction> {
        return this.httpClient.get<Attraction>(this._attractionRoute + 'by-name/' + pageLayoutName);
    }


    doRadiusSearch(_marketZip, _radius): Observable<any[]> {
        return this.httpClient.get<any>(this._attractionRoute + 'attractions-in-radius/' + _marketZip + '/' + _radius);
    }


    selectAllSearch(searchTerms: Attraction): Observable<AttractionApi> {
        searchTerms['selectAll'] = true;
        return this.httpClient.post<AttractionApi>(this._attractionRoute + 'dataSourceSearch', JSON.stringify(searchTerms), this.headerOptions);
    }


    getCustomDatasource(searchParams, sortField, sortDirection, pageNumber: number, pageSize: number): Observable<AttractionApi> {
        searchParams['selectAll'] = false;
        searchParams.sortField = (sortField && sortField !== '') ? sortField : 'createdAt';
        searchParams.sortOrder = (sortDirection && sortDirection !== '') ? sortDirection : 'desc';
        searchParams.pageNumber = (pageNumber && pageNumber !== undefined) ? pageNumber : 0;
        searchParams.pageSize = (pageSize && pageSize !== undefined) ? pageSize : 10;
    
        return this.httpClient.post<AttractionApi>(this._attractionRoute + 'dataSourceSearch', JSON.stringify(searchParams), this.headerOptions); 
    }


    delete(_attraction: Attraction): Observable<any> {
        return this.httpClient.delete(this._attractionRoute + _attraction._id, this.headerOptions);
    }
}